import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { join } from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import Yup from 'yup';
import DropdownWrapper from '../DropdownWrapper';
import TextFieldWrapper from '../TextFieldWrapper';
import { GridItem } from '../../Grid';
import { STATES } from './constants';

const STREET_ADDRESS = 'streetAddress';
const SECONDARY_STREET_ADDRESS = 'secondaryStreetAddress';
const CITY = 'city';
const ADDRESS_STATE = 'addressState';
const ZIP_CODE = 'zipCode';

function AddressForm({ paths, required }) {
  return (
    <React.Fragment>
      <GridItem xs={12}>
        <Field
          component={TextFieldWrapper}
          id={STREET_ADDRESS}
          label="Street Address"
          name={join([...paths, STREET_ADDRESS], '.')}
          paths={[...paths, STREET_ADDRESS]}
          required={required}
        />
      </GridItem>
      <GridItem xs={12}>
        <Field
          component={TextFieldWrapper}
          id={SECONDARY_STREET_ADDRESS}
          label="Secondary Street Address"
          name={join([...paths, SECONDARY_STREET_ADDRESS], '.')}
          paths={[...paths, SECONDARY_STREET_ADDRESS]}
        />
      </GridItem>
      <GridItem lg={4} md={12} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={CITY}
          label="City"
          name={join([...paths, CITY], '.')}
          paths={[...paths, CITY]}
          required={required}
        />
      </GridItem>
      <GridItem lg={4} md={6} xs={12}>
        <Field
          component={DropdownWrapper}
          id={ADDRESS_STATE}
          label="State"
          name={join([...paths, ADDRESS_STATE], '.')}
          paths={[...paths, ADDRESS_STATE]}
          required={required}
        >
          {STATES.map(state => (
            <MenuItem key={state} value={state}>
              {state}
            </MenuItem>
          ))}
        </Field>
      </GridItem>
      <GridItem lg={4} md={6} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={ZIP_CODE}
          label="Zip"
          name={join([...paths, ZIP_CODE], '.')}
          paths={[...paths, ZIP_CODE]}
          required={required}
        />
      </GridItem>
    </React.Fragment>
  );
}

AddressForm.propTypes = {
  paths: PropTypes.array,
  required: PropTypes.bool,
};

const defaultRequired = true;

AddressForm.defaultProps = {
  paths: [],
  required: defaultRequired,
};

export default AddressForm;

export function getAddressValidation(config = {}) {
  const { required = defaultRequired } = config;
  const citySchema = Yup.string();
  const secondaryStreetSchema = Yup.string();
  const stateSchema = Yup.string();
  const streetSchema = Yup.string();
  const zipSchema = Yup.string().matches(/(^\d{5}$)|(^\d{5}-\d{4}$)/, {
    excludeEmptyString: true,
    message: 'Please enter a valid zip code.',
  });

  return {
    [ADDRESS_STATE]: required
      ? stateSchema.required('State is required.')
      : stateSchema,
    [CITY]: required ? citySchema.required('City is required.') : citySchema,
    [STREET_ADDRESS]: required
      ? streetSchema.required('Street address is required.')
      : streetSchema,
    [SECONDARY_STREET_ADDRESS]: secondaryStreetSchema,
    [ZIP_CODE]: required
      ? zipSchema.required('Zip code is required.')
      : zipSchema,
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/form/AddressForm/AddressForm.js